import styled from 'styled-components';
import { Loader2 } from '@styled-icons/remix-line';

export const Loading = styled(Loader2).attrs({
  size: 24,
  className: 'icon-spin',
})``;
